export default "__VITE_ASSET__78d36921__"